export type ParseError = {
  error: unknown;
};

export const safeParse = (str?: string | null) => {
  try {
    return JSON.parse(str || 'null') as object;
  } catch {
    return { error: str };
  }
};

export const MODAL_EXPIRY = 20;

export const formatPrice = (price: number) => {
  return typeof price === 'number' ? `£${(price / 100).toFixed(2)}` : '-';
};
